import { ContactEmployee } from '@/api/contact-employee/contact-employee.types';
import { InfoPair } from '@/components/base/info-pair.component';
import { List, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ContactInformationProps {
  contactEmployee: ContactEmployee | undefined;
  isLoading: boolean;
}

export function ContactInformation({
  contactEmployee,
  isLoading,
}: ContactInformationProps) {
  const { t } = useTranslation('customer');

  return (
    <>
      <Typography variant={'subtitle2'}>{t('account.myData.contactInfo')}</Typography>
      <List disablePadding>
        <InfoPair
          label={t('account.myData.contactFields.name')}
          value={contactEmployee?.name}
          isLoading={isLoading}
        />
        <InfoPair
          label={t('account.myData.contactFields.email')}
          value={contactEmployee?.email}
          isLoading={isLoading}
        />
        <InfoPair
          label={t('account.myData.contactFields.phone')}
          value={contactEmployee?.phone1}
          isLoading={isLoading}
        />
        <InfoPair
          label={t('account.myData.contactFields.mobile')}
          value={contactEmployee?.phone2}
          isLoading={isLoading}
        />
      </List>
    </>
  );
}
